import { useEffect, useState, useCallback } from "react";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Card, Badge, inputCls } from "../components/common";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";
import { ClipboardList, History, ImageIcon } from "lucide-react";

export default function MonitoringTugas() {
  const { user } = useAuth();
  const [active, setActive] = useState([]);
  const [history, setHistory] = useState([]);
  const [tab, setTab] = useState("active");
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    api.get("/tasks/monitor").then((r) => setActive(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(errMsg(e)));
    api.get("/tasks/history").then((r) => setHistory(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const viewProof = async (t) => {
    try {
      const r = await api.get(`/tasks/${t.id}/proof`, { responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
    } catch (e) { toast.error(errMsg(e)); }
  };

  const rows = (tab === "active" ? active : history).filter((t) =>
    !q || (t.title || "").toLowerCase().includes(q.toLowerCase()) || (t.assignee_name || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="monitoring-tugas-page">
      <PageHeader title="Monitoring Tugas" subtitle="Pantau tugas yang Anda berikan: status aktif & riwayat penyelesaian beserta buktinya" testid="monitoring-header" />
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <div className="flex bg-slate-900 border border-slate-800 rounded-lg p-1 gap-1" data-testid="monitoring-tabs">
          <button onClick={() => setTab("active")} data-testid="tab-active" className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors inline-flex items-center gap-1.5 ${tab === "active" ? "bg-emerald-600 text-white" : "text-slate-400 hover:text-slate-200"}`}>
            <ClipboardList className="w-3.5 h-3.5" /> Aktif ({active.length})
          </button>
          <button onClick={() => setTab("history")} data-testid="tab-history" className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors inline-flex items-center gap-1.5 ${tab === "history" ? "bg-emerald-600 text-white" : "text-slate-400 hover:text-slate-200"}`}>
            <History className="w-3.5 h-3.5" /> Riwayat Selesai ({history.length})
          </button>
        </div>
        <input className={`${inputCls} !w-56 ml-auto`} placeholder="Cari tugas / penerima..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="monitoring-search" />
      </div>

      <div className="space-y-2" data-testid="monitoring-list">
        {rows.length === 0 && <Card><p className="text-slate-500 text-sm">{tab === "active" ? "Tidak ada tugas aktif." : "Belum ada riwayat tugas selesai."}</p></Card>}
        {rows.map((t) => (
          <Card key={`${tab}-${t.id}`} className="!p-4" testid={`monitoring-item-${t.id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-sm font-medium text-slate-200 flex-1 min-w-[160px]">{t.title}</span>
              {tab === "history" && <Badge tone={t.final_status === "done" ? "emerald" : "rose"} data-testid={`monitoring-status-${t.id}`}>{t.final_status === "done" ? "Selesai" : "Ditolak"}</Badge>}
              {t.source_module !== "manual" && <Badge tone="cyan">{t.source_module}</Badge>}
              {t.completion_photo_path && (
                <button onClick={() => viewProof(t)} className="inline-flex items-center gap-1 text-[10px] font-mono text-emerald-400 border border-emerald-500/40 rounded-full px-2 py-0.5" data-testid={`monitoring-proof-${t.id}`}>
                  <ImageIcon className="w-2.5 h-2.5" /> Bukti
                </button>
              )}
            </div>
            <div className="text-[11px] text-slate-500 mt-1.5 flex gap-3 flex-wrap">
              <span>Penerima: {t.assignee_name}</span>
              <span>Pemberi: {t.created_by || "sistem"}</span>
              {t.due_date && <span>Tempo: {fmtDate(t.due_date)}</span>}
              {tab === "history" && t.archived_at && <span>Selesai: {fmtDate((t.archived_at || "").slice(0, 10))} oleh {t.archived_by}</span>}
              {tab === "active" && <span>Dibuat: {fmtDate((t.created_at || "").slice(0, 10))}</span>}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
